"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var encrypt_1 = require("./common/encrypt");
var remove_params_from_history_1 = require("./common/remove-params-from-history");
var url_param_1 = require("./common/url-param");
var dataFromUrl = null;
populateDataFromUrl();
remove_params_from_history_1.removeParamsFromHistory(['cdc']);
function populateDataFromUrl() {
    var cdc = url_param_1.urlParamsToObj(window.location.search).cdc;
    if (!cdc) {
        return;
    }
    var data = encrypt_1.decode(cdc);
    if (!data.isCrossDomainCookie) {
        return;
    }
    dataFromUrl = data;
}
function getDataFromUrl() {
    return dataFromUrl;
}
exports.getDataFromUrl = getDataFromUrl;
